import React from 'react';
import './BasketItem.css';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { useStateValue } from './StateProvider';

function BasketItem({ item }) {

    //pull out the data
    const [{ basket }, dispatch] = useStateValue();

    const removeFromBasket = (e) => {
        e.preventDefault();
        //remove the item from basket > we have to update the state(variables) using reducer hooks > hence we have to use dispatch function defined in reducer with the help of stateprovider 
        console.log(`REMOVE ID;{item.id} `);
        dispatch({
            type: 'REMOVE_FROM_BASKET',
            id: item.id
        });

    }





    return (
        <div className="basketItem" key={item.id}>
            <div className="basketItem__img">
                <img className="img-fluid" src={item.imgUrl} alt="basket image logo" />
            </div>
            <div className="basketItem__title">
                <p> {item.title.slice(0, 40) + "..."}</p>
                <small> sold by: Mangesh</small>
                <br />
                {Array(item.ratings).fill(1).map(e => '⭐')}

            </div>

            <div className="basketItem__quant">
                <p> Qty: {item.qty} </p>
            </div>
            <div className="basketItem__price">
                <span className="basketItem__oprice">
                    ₹{item.oprice}
                </span>

                <span
                    className="basketItem__mprice">
                    ₹{item.mprice}
                </span>
                <div>

                </div>
                <div className="basketItem__remove">
                    <HighlightOffIcon onClick={removeFromBasket} />
                </div>




            </div>






        </div>
    )
}

export default BasketItem
